import styled, {css} from 'styled-components';

type TStyledMenuItem = {
	isDragging?: boolean;
	isDisabled?: boolean;
};

export const StyledMenuItem = styled.div<TStyledMenuItem>`
	max-width: 60px;
	height: 66px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 6px;

	.content-menu-item {
		flex: 1;
		margin: 0;
		font-family: Roboto;
		font-size: 11px;
		line-height: 13px;
		text-align: center;
		color: #7f7f7f;

		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.wrapper-icon {
		width: 34px;
		height: 34px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;

		i {
			color: #595959;
			font-size: 20px;
		}

		img {
			width: 24px;
			height: auto;
			border-radius: inherit;
		}

		svg {
			color: #595959;
			width: 24px;
			height: 24px;
		}
	}

	${({isDragging}) =>
		isDragging &&
		css`
			.wrapper-icon {
				background-color: #fff;
				border: 1px dashed #bebebe;
				/* border-radius: 999px;

				img {
					border-radius: inherit;
				} */
			}

			.content-menu-item {
				display: none;
			}
		`}

	${({isDisabled}) =>
		isDisabled &&
		css`
			cursor: not-allowed !important;

			.content-menu-item {
				color: #7f7f7f;
			}
			.wrapper-icon {
				* {
					color: #a2a2a2 !important;
				}

				img {
					opacity: 0.5 !important;
				}
			}
		`}

	:hover {
		${({isDisabled}) =>
			!isDisabled &&
			css`
				.wrapper-icon {
					background-color: #deeffe;
				}
			`}
	}
`;

export const StyledClone = styled(StyledMenuItem)`
	+ div {
		display: none !important;
	}
	.wrapper-icon {
		background-color: #deeffe;
	}
`;
